import { combineReducers } from "redux";
import servicedescription from "../features/admin/services/servicedescription/Slice";
import exceptionals from "../features/admin/services/exceptional/Slice";
import highlights from "../features/admin/services/highlights/Slice";
import philosophies from "../features/admin/services/philosophy/Slice";
import excellences from "../features/admin/services/excellence/Slice";
import testimonials from "../features/admin/services/testimonial/Slice";


const services = combineReducers({

  servicedescription:servicedescription,
  exceptionals:exceptionals,
  highlights:highlights,
  philosophies:philosophies,
  excellences:excellences,
  testimonials:testimonials,
  
});


export default services;